import { render } from "./App.vue?vue&type=template&id=0de5fc47&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "@ionic/core/css/core.css?vue&type=style&index=0&lang=css&external"
import "@ionic/core/css/ionic.bundle.css?vue&type=style&index=1&lang=css&external"
import "./assets/css/dne-app.css?vue&type=style&index=2&lang=css&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__